import { BISelect } from '@pulsepointinc/bi-components';
import styled from 'styled-components';

export const StyledBISelect = styled(BISelect)<{ filterName: string }>`
  width: 100%;
`;
